import * as React from "react";
const SvgFiRrTrashRestore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.11 4h-4.102a5.01 5.01 0 0 0-4.899-4h-2A5.01 5.01 0 0 0 6.21 4h-4.1a1 1 0 1 0 0 2h.86l1.295 13.479A4.98 4.98 0 0 0 9.243 24h5.727a4.98 4.98 0 0 0 4.978-4.528L21.224 6h.886a1 1 0 1 0 0-2m-11-2h2c1.303 0 2.414.836 2.827 2H8.281a3.005 3.005 0 0 1 2.828-2m6.847 17.283A2.99 2.99 0 0 1 14.97 22H9.243a2.99 2.99 0 0 1-2.987-2.713L4.98 6h14.237zm-2.25-6.802a.999.999 0 1 1-1.414 1.414L13 12.602V17a1 1 0 1 1-2 0v-4.398l-1.293 1.293a.999.999 0 1 1-1.414-1.414l1.613-1.614a2.966 2.966 0 0 1 4.188 0z"
    />
  </svg>
);
export default SvgFiRrTrashRestore;
